import React from 'react';
import {Label} from '@gravity-ui/uikit';

export const getStatusLabel = (status: string) => {
  switch (status) {
    case 'Cancelled':
      return (
        <Label size="xs" theme="danger">
          Отменен
        </Label>
      );
    case 'Completed':
      return (
        <Label size="xs" theme="success">
          Завершен
        </Label>
      );
    case 'Active':
      return (
        <Label size="xs" theme="normal">
          Активен
        </Label>
      );
    case 'Pending':
      return (
        <Label size="xs" theme="normal">
          В ожидании
        </Label>
      );
    case 'AmountCollected':
      return (
        <Label size="xs" theme="success">
          Средства собраны
        </Label>
      );
    case 'Created':
      return (
        <Label size="xs" theme="normal">
          Создан
        </Label>
      );
    case 'Published':
      return (
        <Label size="xs" theme="normal">
          Опубликован
        </Label>
      );
    default:
      return (
        <Label size="xs" theme="normal">
          {status}
        </Label>
      );
  }
};
